import { FormItem } from '../../../../commons/Form/Form.types';
import { CreateConsultThirdStepFormSchema } from './CreateConsultThirdStep.types';

export const createConsultThirdStepData: FormItem<CreateConsultThirdStepFormSchema>[][] = [
  [
    {
      name: 'visitOnSite',
      label: 'Visite sur site',
      type: 'checkbox',
    },
  ],
  [
    {
      name: 'firstName',
      placeholder: 'Votre prénom...',
      label: 'Prénom de la personne à contacter',
      type: 'text',
      required: true,
    },
    {
      name: 'lastName',
      placeholder: 'Votre nom...',
      label: 'Nom de la personne à contacter',
      type: 'text',
      required: true,
    },
  ],
  [
    {
      name: 'email',
      placeholder: 'Votre adresse email...',
      label: 'Adresse email de la personne à contacter',
      type: 'text',
      required: true,
    },
    {
      name: 'phone',
      placeholder: 'Votre numéro de téléphone...',
      label: 'Téléphone de la personne à contacter',
      type: 'tel',
      required: true,
    },
  ],
];
